import * as _ from 'lodash-es';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpUtils } from '../utils/httpUtils';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
@Injectable()
export class ExecutionAuditService {

    constructor(private http: HttpClient) {
    }

    getAuditByAction(idExecution: number, idAction: number): Observable<any> {
        const url =  `${environment.thermalUrl}/executionAudit/${idExecution}/${idAction}`;

        return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

}